export default class adUnit {
  constructor() {
    this.code = '';
    this.renderer = {
      options: {
        text: 'Tappx Display',
      },
    };
    this.mediaTypes = {};
    this.bids = [];
  }

  setCode(divId) {
    this.code = divId;
    return this;
  }

  setRenderer(renderer) {
    this.renderer = renderer;
    return this;
  }

  setMediaTypes(mediaTypes) {
    this.mediaTypes = mediaTypes;
    return this;
  }

  /**
   * https://docs.prebid.org/dev-docs/adunit-reference.html#adUnit.mediaTypes.banner
   * @param {*} name
   * @param {*} pos OpenRTB page position value: 0=unknown, 1=above-the-fold, 3=below-the-fold, 4=header, 5=footer, 6=sidebar, 7=full-screen
   * @param {*} sizes
   * @returns
   */
  setMediaTypeBanner(name = null, pos = null, sizes = null) {
    const banner = {
      name,
      pos,
      sizes,
    };

    this.mediaTypes = {
      banner,
    };
    return this;
  }

  setMediaTypeVideo(playerSize = null) {
    const video = {
      pos: 0, // unknown
      context: 'instream',
      placement: 1, // in-stream
      plcmt: 1, // in-stream
      playerSize,
      api: [2], // vpaid2.0
      mimes: ['video/mp4'],
      protocols: [2, 3, 5, 6, 7, 8], // VAST 2.0, VAST 3.0, VAST 2.0 Wrapper, VAST 3.0 Wrapper, VAST 4.0, VAST 4.0 Wrapper
      // playbackmethod,
      linearity: 1, // Linear / In-Stream
      // skip: where 0 = no, 1 = yes.
    };

    this.mediaTypes = {
      video,
    };
    return this;
  }

  setBid(bid) {
    this.bids.push(bid);
    return this;
  }

  setBids(bids) {
    this.bids = this.bids.concat(bids);
    return this;
  }

  build() {
    return {
      code: this.code,
      renderer: this.renderer,
      mediaTypes: this.mediaTypes,
      bids: this.bids,
    };
  }
}
